// 官网域名：hotel.xinjingtech.net
// 管理平台域名：cloud.hotel.xinjingtech.net
// 内部管理后台： hotel.internal.xinjngtech.com
// 后台预发布环境：pre.xinjngtech.com
// 内部后台预发布环境：pre.internal.xinjngtech.com
// 测试官网域名：test.hotel.xinjingtech.net

let base;
let domain = window.location.host;
let hotelType = domain.indexOf('localhost') !== -1;
base = hotelType ? 'test.crm.xinjngtech.com' : domain;
export default base;



// WEBPACK FOOTER //
// ./src/api/domin.js